"use client";

import { useReadContract } from "wagmi";
import { MINER_ABI } from "@/contract/abi/miner";
import { useEffectiveAddress } from "@/hooks/auth/useEffectiveAddress";

export const useFetchMyNFTs = (nftCollectionAddress: `0x${string}`) => {
  const address = useEffectiveAddress();

  return useReadContract({
    abi: MINER_ABI,
    functionName: "getUserTokens",
    args: [address as `0x${string}`],
    address: nftCollectionAddress,
    query: {
      enabled: !!address || !!nftCollectionAddress,
    },
  });
};
